import { SlideLayout, ViewMode } from '@gripp/shared-ui';
import { StyleSheet } from 'react-native';
import { AccountInviteForm } from './accountInviteForm';
import { AccountsComponent } from './accountsComponent';
import { AccountsFilters } from './accountsFilters';

export const AccountInvite = () => {
  const leftColumn = {
    title: 'people.menu.people',
    mainComponent: <AccountsComponent />,
    headerComponent: <AccountsFilters />,
    disableScroll: true
  };

  const rightColumn = {
    title: 'plusMenu.invite',
    mainComponent: <AccountInviteForm />,
    showBackButton: true,
    disableScroll: true
  };

  return (
    <SlideLayout 
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  )
};

const styles = StyleSheet.create({});
